import { DateTime } from 'luxon'
import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ClinTheme } from '../../../../ClinTheme'
import { ClinIcon } from '../../../../components/ClinIcon'
import { ClinIconPathName } from '../../../../components/ClinIcon/ClinIcon.paths'
import { ClinText } from '../../../../components/ClinText'
import i18n from '../../../../i18n/config'
import {
  StyledCutOffText,
  StyledEstimatedDeliveryDate,
  StyledEstimatedDeliveryText,
  StyledExpecterDeliveryTimeText
} from './EstimatedDeliveryDate.styles'

interface IClinEddProps {
  expectedDeliveryDate: string | undefined
  cutOffTime: string | undefined
}

export const EstimatedDeliveryDate: FunctionComponent<IClinEddProps> = ({
  expectedDeliveryDate,
  cutOffTime
}) => {
  const { t } = useTranslation()

  return (
    <StyledEstimatedDeliveryDate>
      <ClinIcon
        iconName={ClinIconPathName.OrderBox}
        iconSize={ClinTheme.space[6]}
        iconFill={ClinTheme.colors.primaryMid}
      />
      <StyledEstimatedDeliveryText>
        <ClinText
          as="div"
          color={ClinTheme.colors.primaryMid}
          fontSize={ClinTheme.fontSizes[0]}
          fontWeight={ClinTheme.fontWeights.medium}
          lineHeight={ClinTheme.lineHeights.largeParagraph}
        >
          {t('product_detail:estimated_delivery_title')}
        </ClinText>

        <ClinText
          as="div"
          className={'unit-price'}
          color={ClinTheme.colors.primaryMid}
          whiteSpace="normal"
          letterSpacing={ClinTheme.space[0]}
        >
          <>
            <Trans
              i18nKey="product_detail:estimated_delivery_time_and_cut_off_time"
              components={{
                StyledExpecterDeliveryTimeText: (
                  <StyledExpecterDeliveryTimeText />
                ),
                br: <br />,
                StyledCutOff: <StyledCutOffText />
              }}
              values={{
                ExpectedDate: DateTime.fromISO(expectedDeliveryDate ?? '', {
                  zone: 'utc'
                })
                  .setLocale(i18n.language)
                  .toFormat('cccc, MMMM d'),
                CutOffTime: DateTime.fromISO(cutOffTime ?? '', {
                  zone: 'utc'
                })
                  .setLocale(i18n.language)
                  .toFormat('HH:mm')
              }}
            >
              <></>
            </Trans>
          </>
        </ClinText>
      </StyledEstimatedDeliveryText>
    </StyledEstimatedDeliveryDate>
  )
}
